import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Tabs, Input, Loading, Toast, Dialog } from "@xp-design/mobile";
import { getClientEnv, goToPage } from "@/utils/tools";
import "./index.less";
import { conversion_cancel } from "./ajax";
import { getUserInfo } from "@/api/common";
import AlertModal from "./component/AlertModal";
import { trackGdp } from "@/utils/gio-report";
import { goToNativePage } from "@/utils/common";
import icon_right_black from "@/assets/icon_right_blackX2.png";
import RulesTxt from "./component/RulesTxt";
import PageContainer from "@/component/pageContainer";
import style from "./index.module.less";
import { getCurrentUid } from "@/api/common";
import { conversion_list } from "./ajax";
import { goToPageV2 } from "@/utils/common";
import { processOssImage } from "@/utils/image";
import { getTopicPageUrl } from "@/utils/url";
import { PURCHASE_AGREEMENT_PAGE_CODE, VIP_RULES_PAGE_CODE } from "@/utils/constants";
const App = () => {
  const location = useLocation();
  const [userUid, setUserUid] = useState<string | null>(null);
  const [phoneNum, setPhoneNum] = useState("xxxx");
  const [tab1Value, setTab1Value] = useState(""); // 初始值可以根据需要设置
  const [tab2Value, setTab2Value] = useState("");
  const [activeKey, setActiveKey] = useState(() => {
    return sessionStorage.getItem("activeTab") || "tab1";
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visibleMask, setvisibleMask] = useState(false);
  const [isRuleShow, setIsRuleShow] = useState(false);
  // 关闭蒙版
  const closeModal = () => {
    setIsModalVisible(false);
    setvisibleMask(false);
  };
  // 关闭兑换弹窗
  const closeAlertModal = () => {
    activeKey === "tab1" ? setTab1Value("") : setTab2Value("");
    closeModal();
  };
  // 关闭兑换规则弹窗
  const closeRule = () => {
    setIsRuleShow(false);
    setvisibleMask(false);
  };
  const [alertProps, setAlertProps] = useState<{
    title: string;
    msg?: string;
    remark?: string;
    buttonTxt?: string;
    onButtonClick: () => void;
  }>({
    title: "提示",
    onButtonClick: () => {
      /* 初始的按钮点击处理函数 */
    },
  });
  // 判断是否开启暗黑模式
  const checkDarkMode = () => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      console.log("开启暗黑模式了");
      return true;
    } else {
      console.log("没有开启暗黑模式");
      return false;
    }
  };

  const inputsty = {
    // border: "2rem solid #ccc",
    height: "106rem",
    borderRadius: " 16rem",
    padding: "0 24rem",
    fontSize: "32rem",
    // fontFamily: '思源黑体',
    background: "#F7F8FA",
    fontWeight: 400,
    // marginTop: "20px",
  };

  const [isWideScreen, setIsWideScreen] = useState(false);
  const handleResize = () => {
    const newIsWideScreen = window.innerWidth >= 1200;
    // console.log(window.innerWidth);
    if (newIsWideScreen !== isWideScreen) {
      setIsWideScreen(newIsWideScreen);
    }
    // 如果现在是宽屏，则滚动到.wrap中间
    if (newIsWideScreen) {
      const wrap = document.querySelector(".wrap");
      if (wrap) {
        wrap.scrollLeft = (wrap.scrollWidth - wrap.clientWidth) / 2;
      }
    }
  };
  // const conversion1=()=>{
  //   const res={
  //     title:"兑换成功,发放中",
  //     msg:"获得 xxx券",
  //     remark:"随卡附赠 嘻嘻嘻打赏",
  //     button:"查看充电卡包",
  //     exchangeProductCode:"1"
  //   }
  //   const data:any = res;
  //   setIsModalVisible(true);
  //   setAlertProps({
  //     title: data.title,
  //     msg: data.msg,
  //     remark: data.remark,
  //     buttonTxt: data.button,

  //     onButtonClick: () => {
  //       activeKey === "tab1" ? setTab1Value('') : setTab2Value('')
  //       setIsModalVisible(false); // 点击确认按钮后关闭弹窗
  //       trackGdp('P20181', 'B005', {trackName:'充电福利兑换_兑换结果弹窗操作',click_type:data.button,});
  //       if(data.button){
  //         const { origin, pathname } = window.location;
  //         if(data.button==='查看兑换记录'){

  //         goToPage(`${origin}/apps/charge-web/par-marketing.html#/exChangeDetail`);
  //         }else if(data.button==='查看充电卡包'){
  //           // goToNativePage({mini:'charging/pages/voucher-list/index',app:"xiaopeng://charging/card?type=0"});
  //           const exchangeProductCode=data.exchangeProductCode;
  //           const exchangeProductSmallCode=data.exchangeProductSmallCode;
  //           if (exchangeProductCode == "6" ||exchangeProductCode == "1") {
  //             //券包\券
  //             goToNativePage({
  //               mini: "charging/pages/voucher-list/index?tabIndex=1",
  //               app: "xiaopeng://charging/card?type=1",
  //               browser:`https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=1")}`

  //             });
  //           } else if (
  //             //电卡
  //             exchangeProductCode == "11" ||
  //             exchangeProductCode == "5"
  //           ) {
  //             if(exchangeProductSmallCode=='07'){//储值卡
  //               goToNativePage({
  //                 mini: "charging/pages/voucher-list/index?tabIndex=2",
  //                 app: "xiaopeng://charging/card?type=2",
  //                 browser:`https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=2")}`

  //               });
  //             }else{
  //               goToNativePage({
  //                 mini: "charging/pages/voucher-list/index",
  //                 app: "xiaopeng://charging/card?type=0",
  //                 browser:`https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=0")}`

  //               });
  //             }
  //           } else if (exchangeProductCode == "7") {
  //             goToPage(`${origin}/apps/charge-web/charge-vip.html`);
  //           }
  //         }else if(data.button==='去VIP主页'){
  //           goToPage(`${origin}/apps/charge-web/charge-vip.html`);
  //         }
  //       }
  //     },
  //   });
  // }
  // 获取兑换列表接口数据
  const fetchInitialData = async () => {
    try {
      Loading.show("请求中...");
      const userUid = await getCurrentUid();
      console.log("userUid", userUid);
      const param = {
        conversionCodeStatusCode: "10,20",
        userUid,
        redirectUrl: "http://chargegateway.test.xiaopeng.local",
        pageSize: 100,
        pageNo: 1,
      };

      // const res={
      //   total:14,
      //   records:[{
      //     conversionCodeBatch:"125",
      //     conversionCodeCode: "CDKF1CBC814860896",
      //     conversionCodeId: 2362331,
      //     conversionCodeStatusCode: "20",
      //     conversionCodeStatusName: "兑换成功",
      //     conversionCodeStatusTime: 1739507401000,
      //     conversionTemplateId: 91,
      //     conversionTemplateName: "VIP储值卡赠品-停用",
      //     exchangeItemId: "VIP2025021114144029729714621209",
      //     exchangeItemName: "VIP储值卡赠品-停用",
      //     exchangeProductCode: "7",
      //     exchangeProductName: "充电VIP卡",
      //     exchangeProductSmallCode: "7",
      //     exchangeProductSmallName: "充电VIP卡",
      //     failInfo: "",
      //     failUserUid: null,
      //     goodsExchangedCode: "7",
      //     goodsExchangedName: "充电VIP卡",
      //     remark: "",
      //     userUid: "8132818",
      //     verificationCompletionTime: 1739507401000,
      //     verificationMode: "1",
      //     verificationOperatorId: "8132818",
      //     verificationOperatorName: "C端客户",
      //     verificationOperatorTime: 1739258712000,
      //     vipSendFlag: "0",
      //   }]
      // }

      const res = await conversion_list(param);
      const jsonData = JSON.stringify(res);
      sessionStorage.setItem("exchangeCardList", jsonData);
    } catch (error) {
      console.error("Failed to fetch cards data:", error);
    } finally {
      Loading.hide();
      const { origin, pathname } = window.location;
      goToPage(`${origin}${pathname}#/exChangeDetail`);
      trackGdp("P20181", "B002", {
        trackName: "充电福利兑换_兑换记录点击",
      });
    }
  };
  const transformValue = (exchangeProductSmallCode: string | undefined) => {
    switch (exchangeProductSmallCode) {
      // 电量卡
      case "06":
        return "3";
        break;
      // 次数卡
      case "04":
        return "1";
        break;
      // 整单折扣卡
      case "05":
        return "5";
        break;
      // 储值卡
      case "07":
        return "07";
        break;
      // 服务费折扣卡
      case "08":
        return "6";
        break;
      default:
        return "-1";
    }
  };
  const conversion = async () => {
    try {
      if (
        (activeKey === "tab1" && tab1Value) ||
        (activeKey === "tab2" && tab2Value)
      ) {
        Loading.show("请求中...");
        const param = {
          // test:true,
          redirectUrl: "http://chargegateway.test.xiaopeng.local",
          conversionCodeCode: activeKey === "tab1" ? tab1Value : tab2Value,
          userUid: userUid,
          verificationMode: 1,
          goodsExchangedPort: activeKey === "tab1" ? 1 : 2,
        };
        const res = await conversion_cancel(param);
        trackGdp("P20181", "B003", {
          trackName: "充电福利兑换_兑换按钮点击",
          result: res.title || res.code,
        });
        const data: any = res;
        setIsModalVisible(true);
        setvisibleMask(true);
        // redeem_type兑换商品类型
        trackGdp("P20181", "B004", {
          trackName: "充电福利兑换_兑换结果弹窗展示",
          redeem_type: data.redeem_type,
          result: data.title,
          tips: data.msg + " " + data.remark,
        });
        setAlertProps({
          title: data.title,
          msg: data.msg,
          remark: data.remark,
          buttonTxt: data.button,
          // msg: '获得新用户专享-充电VIP月卡',
          // remark:'随卡附赠专属空投优惠|15元充电包',
          // buttonTxt:'去VIP主页',
          onButtonClick: () => {
            if (activeKey === "tab1") {
              setTab1Value("");
            } else {
              setTab2Value("");
            }
            setIsModalVisible(false); // 点击确认按钮后关闭弹窗
            setvisibleMask(false);
            trackGdp("P20181", "B005", {
              trackName: "充电福利兑换_兑换结果弹窗操作",
              click_type: data.button,
            });
            if (data.button) {
              const { origin, pathname } = window.location;
              if (data.button === "查看兑换记录") {
                // goToPage(`${origin}${pathname}#/exChangeDetail`)
                goToPage(
                  `${origin}/apps/charge-web/par-marketing.html#/exChangeDetail`,
                );
              } else if (data.button === "查看充电卡包") {
                // goToNativePage({mini:'charging/pages/voucher-list/index',app:"xiaopeng://charging/card?type=0"});
                const exchangeProductCode = data.exchangeProductCode;
                const exchangeProductSmallCode = data.exchangeProductSmallCode;
                if (exchangeProductCode == "6") {
                  //券包
                  goToNativePage({
                    mini: "/charging/pages/voucher-list/index?tabIndex=1",
                    app: "xiaopeng://charging/card?type=1",
                    browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=1")}`,
                  });
                  // 充电券
                } else if (exchangeProductCode == "1") {
                  goToPageV2({
                    url: `${origin}/apps/charge-web/coupon-detail.html?couponId=${data.exchangeItemId}`,
                  });
                } else if (
                  //电卡
                  exchangeProductCode == "11" ||
                  exchangeProductCode == "5"
                ) {
                  if (exchangeProductSmallCode == "07") {
                    //储值卡
                    goToNativePage({
                      mini: `/charging/pages/card-detail/index?cardId=${data.exchangeItemId}&isStore=true`,
                      app: "xiaopeng://charging/card?type=2",
                      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=2")}`,
                    });
                  } else {
                    console.log(
                      `小程序地址：/charging/pages/card-detail/index?cardId=${data.exchangeItemId}&cardTypeId=${transformValue(exchangeProductSmallCode)}`,
                    );
                    goToNativePage({
                      mini: `/charging/pages/card-detail/index?cardId=${data.exchangeItemId}&cardTypeId=${transformValue(exchangeProductSmallCode)}`,
                      app: "xiaopeng://charging/card?type=0",
                      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=0")}`,
                    });
                  }
                } else if (exchangeProductCode == "7") {
                  goToPage(`${origin}/apps/charge-web/charge-vip.html`);
                }
              } else if (data.button === "去VIP主页") {
                goToPage(`${origin}/apps/charge-web/charge-vip.html`);
              }
            }
          },
        });
      } else {
        Toast.show({
          content: "兑换码是必填项！",
        });
        return;
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      Loading.hide();
    }
  };
  const handleTabChange = (key) => {
    setActiveKey(key);
    sessionStorage.setItem("activeTab", key);
    if (key === "tab1") {
      setTab2Value("");
    } else {
      setTab1Value("");
    }
  };
  const clientEnv = getClientEnv();
  const payRule = () => {
    goToPageV2({
      url: getTopicPageUrl(PURCHASE_AGREEMENT_PAGE_CODE[clientEnv]),
    });
  };
  const detailRule = () => {
    goToPageV2({
      url: getTopicPageUrl(VIP_RULES_PAGE_CODE[clientEnv]),
    });
  };
  useEffect(() => {
    const tabKey = sessionStorage.getItem("activeTab");
    checkDarkMode();
    trackGdp("P20181", "B001", { trackName: "充电福利兑换_页面曝光" }); //埋点
    const fetchUserInfo = async () => {
      try {
        const res = await getUserInfo();
        if (res.code === 200) {
          setUserUid(res.data.uid || "");
          if (res.data.mobile) {
            const start = Math.floor((res.data.mobile.length - 4) / 2);
            const end = start + 4;
            // 替换中间四位为星号
            const maskedMobile =
              res.data.mobile.substring(0, start) +
              "****" +
              res.data.mobile.substring(end);
            setPhoneNum(maskedMobile);
          }
        }
      } catch (error) {
        console.error("Failed to fetch userInfo:", error);
      }
    };
    fetchUserInfo(); // 调用异步函数
  }, []);
  useEffect(() => {
    // // 从 URL 的查询参数中获取
    const searchParams = new URLSearchParams(location.search);
    const redemptionType = searchParams.get("redemptionType");
    if (redemptionType && redemptionType == "vip") {
      setActiveKey("tab2");
    }
    // 初始检测
    // handleResize();
    // 监听窗口大小变化
    // window.addEventListener("resize", handleResize);
    // 清理函数，防止内存泄漏
    return () => {
      // window.removeEventListener("resize", handleResize);
    };
  }, [location]); // 依赖 location，以便在 location 变化时重新运行效果
  return (
    <PageContainer
      title="充电福利兑换"
      footerRender={() => {
        return (
          <div className={"bottomDIV3"}>
            <div className="op_1">
              <span
                className="txt"
                onClick={() => {
                  setIsRuleShow(true);
                  setvisibleMask(true);
                }}
              >
                兑换规则
              </span>
              <img src={processOssImage(icon_right_black)} />
            </div>
            <div className="op_2">
              <span
                className="txt"
                onClick={() => {
                  // fetchInitialData()
                  const { origin, pathname } = window.location;
                  // 原来的
                  // goToPage(`${origin}${pathname}#/exChangeDetail`);
                  goToPageV2({
                    url: `${origin}${pathname}#/exChangeDetail`,
                  });
                  trackGdp("P20181", "B002", {
                    trackName: "充电福利兑换_兑换记录点击",
                  });
                }}
              >
                兑换记录
              </span>
              <img src={processOssImage(icon_right_black)} />
            </div>
          </div>
        );
      }}
    >
      <div className={`wrap ${style["pageWarp"]}`}>
        <div className="mainContent">
          <div className="parTip">输入兑换码领取充电福利</div>
          <div className="parTip2">兑换成功后，将发放到账户：{phoneNum}</div>
          <div className="tab">
            <Tabs
              defaultActiveKey="tab1"
              onChange={handleTabChange}
              activeKey={activeKey}
            >
              <Tabs.Tab title="充电卡券" key="tab1">
                <div style={{ position: "relative" }}>
                  <Input
                    clearable
                    size="lg"
                    placeholder="请输入兑换码"
                    value={tab1Value}
                    onChange={(val) => setTab1Value(val)}
                    inputStyle={inputsty}
                  ></Input>
                </div>
              </Tabs.Tab>
              <Tabs.Tab title="充电VIP" key="tab2">
                <Input
                  clearable
                  size="lg"
                  placeholder="请输入兑换码"
                  value={tab2Value}
                  onChange={(val) => setTab2Value(val)}
                  inputStyle={inputsty}
                ></Input>
              </Tabs.Tab>
            </Tabs>
            {isModalVisible && (
              <AlertModal onClose={closeAlertModal} {...alertProps} />
            )}
          </div>
          <div className="subBtn">
            <Button
              size="large"
              type="submit"
              variant="solid"
              shape="round"
              onClick={conversion}
            >
              立即兑换
            </Button>
            {activeKey === "tab2" && (
              <div className="rules">
                <span onClick={payRule}>
                  兑换即同意<a>《购买协议》</a>
                </span>
                <span className="line">|</span>
                <a onClick={detailRule}>详细规则</a>
              </div>
            )}
          </div>
          <div className="footBar"></div>
          <Dialog
            visible={isRuleShow}
            onClose={closeRule}
            getContainer={null}
            title="兑换规则"
            closeOnMaskClick={false}
            bodyClassName="recordCustomDialog"
            content={
              <>
                <RulesTxt onClose={closeRule} />
              </>
            }
          ></Dialog>
        </div>

        {/* 蒙版 */}
        {visibleMask && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)", // 半透明背景
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999, // 确保蒙版位于其他内容之上
            }}
            onClick={(e) => e.stopPropagation()} // 阻止点击事件穿透到蒙版下方的元素
          ></div>
        )}
      </div>
    </PageContainer>
  );
};

export default App;
